import RestraintInteractionHandler3D from "oc-interaction/restraints2/RestraintInteractionHandler3D.js";
import Interior from "./arrangement/Interior";
import PlaneRestraint from "oc-modules/oc-interaction/restraints2/PlaneRestraint";
import { v3 } from "oc-modules/oc-threejs/short3";
import { InteriorRestraint } from "./restraint/InteriorRestraint";
export default class InteractionHandler extends RestraintInteractionHandler3D {

    createDragInterior(interior) {
        const interiorArrangement = new Interior(APP.arrangement, interior, APP.arrangement.booth);
        APP.arrangement.setDraggingInterior(interiorArrangement);
        // APP.arrangement.booth.addInterior(interiorArrangement);
        APP.update3d();
        return interiorArrangement.jaco3d;
    }
    onDrag3dSceneLeave(real) {
        if(real) this.dragObject3d.outsideScene = true;
    }
    onDrag3dSceneEnterImmediate(event) {
        this.dragObject3d.outsideScene = false;
    }

    onDrag3dSceneLeave(real) {
        if(real) this.dragObject3d.outsideScene = true;
    }

    onDrag3dSceneEnterImmediate(event) {
        this.dragObject3d.outsideScene = false;
    }

    onDrag3dEnd() {
        super.onDrag3dEnd();
        console.log(this.dragObject3d.outsideScene);
        this.dragObject3d.jaco.position.copy(this.dragObject3d.position);
        this.lastDragged = this.dragObject3d.jaco;
        APP.arrangement.draggingInterior = undefined;
        if (this.dragObject3d.outsideScene) {
            this.dragObject3d.jaco.positionValid = false;
            this.dragObject3d.onDrop();
        }
    }

    decideAboutInteriorParent(interior) {
        if(!interior.positionValid) {
            APP.arrangement.booth.removeInterior(interior);
            APP.arrangement.interiorSpace.addInterior(interior);
        } else if(interior.positionValid) {
            APP.arrangement.interiorSpace.removeInterior(interior);
            if(APP.arrangement.booth.interiors.find(inter => inter.jaco3d.uuid == interior.jaco3d.uuid) == undefined) APP.arrangement.booth.addInterior(interior);
        }
        APP.dirty();
    }


    getRestraintsAndSnapsForHandle() {
        const boothFloors = [];
        _.forEach(APP.arrangement.boothFloors, (v, k) => boothFloors.push(v));
        APP.arrangement.interiorRestraint = new InteriorRestraint ({
            priority: 4,
            collisionHeightIntervalls: [0,0.2,0.4,0.6,0.8,1,1.5,2],
            polygonSimplifyTollerance: 0.01,
            freeOrientationAroundMainAxis: true,
            offset: 0,
            showDebugVisualization: false,
        });

        return [
            APP.arrangement.interiorRestraint,
            ...boothFloors,
            // new PlaneRestraint({
            //     defaultAnchorBoxPosition: v3(0,0,0),
            //     freeOrientation: true
            // }),
        ];
    }

    /**
     * @private
     */
     _triggerTapObject3D(event) {
        const proceedWithTab = this.onTapObject3D(event);
        if (proceedWithTab===false) {
            return;
        }
        this.tapObject3d.onTap(event);
        STAGE.trigger('tapObject3D',this);
    }


}
